import React from 'react'
import { AppSvg, Avatar, newIcons } from '@web/walter-ui-kit'

import styles from './style.module.css'
import { useUserInfo } from '~api'

interface Props {
    isOpen: boolean
    isAuth: boolean
}

function HeaderMenuButton({ isOpen, isAuth }: Props) {
    const { data: userInfoData } = useUserInfo()
    const userName = userInfoData?.first_name || userInfoData?.user_name || userInfoData?.email || ''

    let content

    if (isAuth) {
        content = <Avatar size={40} src={userInfoData?.avatar_url} label={userName.charAt(0)} />
    } else {
        const iconName = isOpen ? newIcons.ic24Close : newIcons.ic24BurgerMenu
        content = <AppSvg path="new-icons" svgName={iconName} size={24} />
    }

    return (
        <div className={styles.menuButton} data-pointer="menu_button">
            {content}
        </div>
    )
}

export default HeaderMenuButton
